import HttpClient from '@/util/http/HttpClient';
import ApiWrapper from '@/repositories/data/ApiWrapper';
import { Observable, of } from 'rxjs';
import Resource from '@/repositories/Resource';
import { networkBoundResource, unwrapApiWrapper } from '@/repositories/BaseCrudRepository';

export default class NgtMediaRepository {
    protected readonly client: HttpClient;
    protected readonly baseUrl: string;

    constructor(client: HttpClient) {
        this.client = client;
        this.baseUrl = process.env.VUE_APP_API_ENDPOINT + '/api/rest/ngt-media';
    }

    public findGestureFilmsForGlossVariants(query: string): Observable<Resource<{ id: number; label: string }[]>> {
        if (!query || query.length < 3) {
            return of(Resource.success([]));
        }
        const index = query.indexOf('(');
        if (index !== -1) {
            query = query.substring(0, index).trim();
        } else {
            query = query.trim();
        }
        const observable = this.client.get<ApiWrapper<{ id: number; label: string }[]>>('films-by-gloss-variants', {
            baseUrl: this.baseUrl,
            params: {
                query,
            },
        });
        return networkBoundResource(unwrapApiWrapper(observable));
    }

    public findGlossVariantByFilmId(id: any): Observable<Resource<{ id: number; label: string }>> {
        const observable = this.client.get<ApiWrapper<{ id: number; label: string }>>(
            'gloss-variant-by-film-id/' + id,
            { baseUrl: this.baseUrl },
        );
        return networkBoundResource(unwrapApiWrapper(observable));
    }
}
